export enum TemplateCenterActionType {
  GET_TEMPLATE_CENTER_DATA_REQUEST = '@@originator/GET_TEMPLATE_CENTER_DATA_REQUEST',
}
